import axios from 'axios'
import config from '@/config'
import { SET_DEVICE_CONFIGURATION } from '@/store/mutation-types'

export async function fetchDeviceConfiguration ({ commit, state }) {
  try {
    const response = await axios.get(config.backend.rest + 'device/me/')
    const configuration = response.data

    await commit(SET_DEVICE_CONFIGURATION, { configuration })
  } catch (error) {
    // FIXME Implement retry with backoff. And/or error message
  }
}
